module.exports = __webpack_public_path__ + "static/img/002.ffdc83ca.png";